import React, { FC, useMemo } from "react";
import { View } from "react-native";
import { useI18nMessage } from "@lookiero/i18n-react";
import { Text } from "@lookiero/sty-psp-ui";
import { ButtonIcon } from "@lookiero/sty-psp-ui";
import { ReturnQuestionProjection } from "../../../../../../projection/returnQuestion/returnQuestion";
import { ReturnQuestionType } from "../../../../../../projection/returnQuestion/returnQuestion.constants";
import { ReturnQuestions } from "../../../../components/organisms/returnQuestions/ReturnQuestions";
import {
  ReturnQuestionItemProvider,
  ReturnQuestionItems,
} from "../../../../components/organisms/returnQuestions/behaviors/useReturnQuestionItem";
import { HostDefaultReturnQuestionFeedbackItem } from "../../../../components/organisms/returnQuestions/components/hostDefaultReturnQuestionFeedbackItem/HostDefaultReturnQuestionFeedbackItem";
import { ReturnQuestionFeedbackItem } from "../../../../components/organisms/returnQuestions/components/returnQuestionFeedbackItem/ReturnQuestionFeedbackItem";
import { DOMAIN, I18nMessages } from "../../../../i18n/i18n";
import { style as returnQuestionsFeedbackStyle } from "./ReturnQuestionsFeedback.style";

const returnQuestionItems: ReturnQuestionItems = {
  [ReturnQuestionType.HOST_DEFAULT]: HostDefaultReturnQuestionFeedbackItem,
  [ReturnQuestionType.HOST_TEXTAREA]: ReturnQuestionFeedbackItem,
  [ReturnQuestionType.HOST_SELECT]: ReturnQuestionFeedbackItem,
  [ReturnQuestionType.HOST_STACK]: ReturnQuestionFeedbackItem,
  [ReturnQuestionType.TEXTAREA]: ReturnQuestionFeedbackItem,
  [ReturnQuestionType.OPTION]: ReturnQuestionFeedbackItem,
  [ReturnQuestionType.HOST_RADIO_GROUP]: ReturnQuestionFeedbackItem,
};

interface ReturnQuestionsFeedbackProps {
  readonly returnQuestions: ReturnQuestionProjection[];
  readonly onEditFeedback: () => void;
}

const ReturnQuestionsFeedback: FC<ReturnQuestionsFeedbackProps> = ({ returnQuestions, onEditFeedback }) => {
  const titleText = useI18nMessage({ domain: DOMAIN, id: I18nMessages.FEEDBACK_TITLE });

  const style = useMemo(() => returnQuestionsFeedbackStyle(), []);

  return (
    <View>
      <View style={style.titleContainer}>
        <Text level={2}>{titleText}</Text>
        <ButtonIcon name="pencil" testID="edit-feedback" onPress={onEditFeedback} />
      </View>

      <ReturnQuestionItemProvider returnQuestionItems={returnQuestionItems}>
        <ReturnQuestions returnQuestions={returnQuestions} />
      </ReturnQuestionItemProvider>
    </View>
  );
};
export { ReturnQuestionsFeedback };
